import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button } from '@mui/material'
import React, { useState } from 'react'
import { useToast } from "../../contexts/toast";
import { progressToast } from "../../utils/progress-toast";
import { useMailChimpReportMutation } from "../../generated/graphql";
import FileSaver from 'file-saver';

export default function MailChimpContacts() {
    const [isWait, setWait] = useState(false);
    const {toast} = useToast();
    const [mutation] = useMailChimpReportMutation({ fetchPolicy: 'no-cache' });

    async function submitForm() {
        if (isWait) return;
        const t = progressToast(toast)('MAILCHIMP_REPORT');
        t.start("Generating report",{variant:'info'});
        setWait(true);
        try {
            const data = await mutation();
            setWait(false);
            t.ok('Rendering file');
            const res = await fetch(data?.data?.mailChimpReport?.reportData);
            const blobContent = await res.blob();
            //const blobUrl = URL.createObjectURL(blobContent);
            FileSaver.saveAs(blobContent,'mailchimp-report-.xlsx');
            //window.open(blobUrl);
            
        } catch (e) {
            console.log('error',e);
            t.fail('Download failed');
            setWait(false);
        }
    }
    return <div><div>
    <Accordion defaultExpanded={true}>
        <AccordionSummary>MailChimp Contacts Export</AccordionSummary>
        <AccordionDetails>
            </AccordionDetails>
            <AccordionActions>
                  <Button variant="contained" onClick={submitForm}>Generate Report</Button>
            </AccordionActions>
    </Accordion></div></div>
}
